/**
 * Markdown Utilities
 *
 * Pandoc extension stripping for clean GFM editing.
 *
 * @module @humanizer/studio/utils/markdown-utils
 */

/**
 * Strip Pandoc-specific extensions from raw markdown.
 *
 * Removes:
 * - `{.class}` / `{#id}` / `{key=value}` attribute blocks
 * - `:::` div fences
 * - `[@citation]` syntax
 * - YAML metadata blocks (leading `---` ... `---`)
 *
 * Returns clean GFM markdown suitable for textarea editing.
 */
export function stripPandocExtensions(raw: string): string {
  let text = raw;

  // Strip YAML front matter (must be at start of document)
  text = text.replace(/^---\n[\s\S]*?\n---\n?/, '');

  // Strip attribute blocks: {.class}, {#id}, {key="value"}, {.class #id}
  text = text.replace(/\{[.#][^}]*\}/g, '');

  // Strip div fences: ::: or :::identifier
  text = text.replace(/^:::\s*\w*\s*$/gm, '');

  // Strip citation syntax: [@key] or [@key, p. 42]
  text = text.replace(/\[@[^\]]+\]/g, '');

  // Clean up any resulting double-blank lines
  text = text.replace(/\n{3,}/g, '\n\n');

  return text.trim();
}
